import { Alert } from 'shared/ui'

type IDowngradeEffectiveDateAlertProps = {
  effectiveDate?: string
  marginBottom?: number
}

export const DowngradeEffectiveDateAlert = ({
  effectiveDate,
  marginBottom = 24,
}: IDowngradeEffectiveDateAlertProps) => {
  if (!effectiveDate) {
    return null
  }

  return (
    <Alert
      item={{
        type: 'warning',
        desc: `The downgrade will take effect at the end of the billing cycle on ${effectiveDate}.`,
      }}
      marginBottom={marginBottom}
    />
  )
}
